import React from "react";
import CreateItemPost from "../Components/CreateItemPost";

export default function Create_Listing_Page() {
  return(
    <div>
      <CreateItemPost/>
    </div>
  )
}